import SectionHeading from '@/pages/home/components/SectionHeading';
import { focusItems } from '@/mocks/home';

export default function FocusSection() {
  const [lead, ...rest] = focusItems;

  return (
    <section id="focus" className="bg-background-50 py-12 md:py-16">
      <div className="mx-auto max-w-[1440px] px-4 md:px-8">
        <SectionHeading
          no="01"
          title="今日焦点"
          en="Focus Today"
          desc="今天更新里最值得先看的三条，带图带时间线，方便你决定要不要继续跟。"
          right={
            <a
              href="#feed"
              className="hidden items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-600 transition-colors hover:text-primary-700 md:flex"
            >
              查看全部动态
              <i className="ri-arrow-right-s-line text-lg" />
            </a>
          }
        />

        <div className="grid gap-4 lg:grid-cols-3 md:gap-5">
          <a
            href="#feed"
            className="group relative block h-[320px] overflow-hidden rounded-lg lg:col-span-2 md:h-[440px]"
          >
            <img
              src={lead.img}
              alt={`${lead.title} - 黑料51黑料动态焦点封面`}
              title={`${lead.title} 黑料51黑料最新`}
              className="absolute inset-0 h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/95 via-foreground-950/40 to-transparent" />
            <div className="absolute inset-x-0 bottom-0 p-5 md:p-7">
              <span className="inline-flex items-center gap-1.5 rounded bg-primary-500 px-2.5 py-1 text-xs font-medium text-background-50">
                <i className="ri-flashlight-fill text-sm" />
                {lead.tag}
              </span>
              <h3 className="mt-3 max-w-2xl font-heading text-xl font-bold leading-snug text-background-50 md:text-3xl">
                {lead.title}
              </h3>
              <p className="mt-3 hidden max-w-xl text-sm text-background-100/80 sm:block">
                {lead.summary}
              </p>
              <div className="mt-4 flex items-center gap-4 text-xs text-background-200/80">
                <span className="flex items-center gap-1">
                  <i className="ri-time-line text-sm" />
                  {lead.time}
                </span>
                <span className="flex items-center gap-1">
                  <i className="ri-fire-line text-sm text-accent-500" />
                  {lead.heat}
                </span>
              </div>
            </div>
          </a>

          <div className="grid gap-4 md:gap-5">
            {rest.map((item) => (
              <a
                key={item.id}
                href="#feed"
                className="group relative block h-[228px] overflow-hidden rounded-lg md:h-[210px]"
              >
                <img
                  src={item.img}
                  alt={`${item.title} - 黑料51黑料线索配图`}
                  title={`${item.title} 黑料51黑料更新`}
                  className="absolute inset-0 h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/95 via-foreground-950/45 to-transparent" />
                <div className="absolute inset-x-0 bottom-0 p-4 md:p-5">
                  <span className="inline-flex items-center rounded bg-accent-500 px-2 py-0.5 text-[11px] font-medium text-foreground-950">
                    {item.tag}
                  </span>
                  <h3 className="mt-2 font-heading text-base font-bold leading-snug text-background-50">
                    {item.title}
                  </h3>
                  <div className="mt-2.5 flex items-center gap-3 text-[11px] text-background-200/80">
                    <span>{item.time}</span>
                    <span className="flex items-center gap-1">
                      <i className="ri-fire-line text-xs text-accent-500" />
                      {item.heat}
                    </span>
                  </div>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}